import { format, isValid } from 'date-fns';

import asyncService from '../asyncService';

export const SAGE_ROUTES = {
  CREATE: 'users/sage/create',
  EVERIFY: 'users/sage/everify',
  PAYROLL: 'sage/payroll',
};

// The Sage routes reject any body field they do not declare, so every request body is
// built here rather than at the call sites.
export const SAGE_FAILURE = {
  ALREADY_IN_SAGE: 'alreadyInSage',
  INVALID_REQUEST: 'invalidRequest',
  MISSING_DOCUMENTS: 'missingDocuments',
  MISSING_SAGE_ID: 'missingSageId',
  NOT_FOUND: 'notFound',
  UNAVAILABLE: 'unavailable',
  UNKNOWN: 'unknown',
};

export const toApiDate = (date) => (isValid(date) ? format(date, 'yyyy-MM-dd') : null);

export const buildPayrollBody = ({ periodStart, periodEnd, corporationIds }) => ({
  periodStart,
  periodEnd,
  ...(corporationIds?.length ? { corporationIds } : {}),
});

/**
 * Turns an axios failure into something the controls can render. A 409 from create is a
 * success for the caller, but it arrives here as a rejection, so it is classified too.
 */
export const classifySageFailure = (error) => {
  const status = error?.response?.status;
  const body = error?.response?.data;

  if (status === 400) {
    if (body?.missingDocumentTypes?.length) {
      return {
        kind: SAGE_FAILURE.MISSING_DOCUMENTS,
        missingDocumentTypes: body.missingDocumentTypes,
      };
    }
    return {
      kind: SAGE_FAILURE.INVALID_REQUEST,
      message: typeof body?.error === 'string' ? body.error : undefined,
    };
  }
  if (status === 404) {
    return { kind: SAGE_FAILURE.NOT_FOUND };
  }
  if (status === 409) {
    if (body?.code === 'sageIdExists') {
      return { kind: SAGE_FAILURE.ALREADY_IN_SAGE, sageId: body.sageId };
    }
    if (body?.code === 'missingSageId') {
      return { kind: SAGE_FAILURE.MISSING_SAGE_ID };
    }
  }
  if (status === 502 || status === 503) {
    return { kind: SAGE_FAILURE.UNAVAILABLE };
  }
  return { kind: SAGE_FAILURE.UNKNOWN };
};

const postSage = ({ route, data, dispatch, token, refreshToken }) =>
  new Promise((resolve, reject) => {
    asyncService({
      httpMethod: 'POST',
      route,
      data,
      onSuccess: (response) => resolve(response?.data),
      onError: (error) => reject(error),
      dispatch,
      token,
      refreshToken,
    });
  });

export const createSageEmployee = ({ userId, dispatch, token, refreshToken }) =>
  postSage({ route: SAGE_ROUTES.CREATE, data: { userId }, dispatch, token, refreshToken });

export const runSageEverify = ({ userId, dispatch, token, refreshToken }) =>
  postSage({ route: SAGE_ROUTES.EVERIFY, data: { userId }, dispatch, token, refreshToken });

export const runSagePayroll = ({
  periodStart,
  periodEnd,
  corporationIds,
  dispatch,
  token,
  refreshToken,
}) =>
  postSage({
    route: SAGE_ROUTES.PAYROLL,
    data: buildPayrollBody({ periodStart, periodEnd, corporationIds }),
    dispatch,
    token,
    refreshToken,
  });
